export default "__VITE_ASSET__CboJcJMG__"